import { FormikTextField } from "../../forms/Formik"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import type { PublicInstitutionDetailsFormValues } from "../billReceiverTypes"

import { DebtorNumberField } from "./DebtorNumberField"
import { DetailsAddressFormSection } from "./DetailsAddressFormSection"
import { DetailsContactFormSection } from "./DetailsContactFormSection"

type PrivatePersonProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function PublicInstitutionForm({ isMerchantAdmin }: PrivatePersonProps) {
    return (
        <>
            <DebtorNumberField isMerchantAdmin={isMerchantAdmin} />
            <LocalizedStrict id="bill-receivers-input-search-label-number-cvr" attrs={{ label: true }}>
                <FormikTextField<PublicInstitutionDetailsFormValues> name="vatnumber" label="VAT number" fullWidth />
            </LocalizedStrict>
            <LocalizedStrict id="bill-receivers-form-label-institution-name" attrs={{ label: true }}>
                <FormikTextField<PublicInstitutionDetailsFormValues>
                    name="institutionName"
                    label="Institution name (*)"
                    fullWidth
                />
            </LocalizedStrict>
            <DetailsAddressFormSection />
            <DetailsContactFormSection />
        </>
    )
}
